module.exports = __webpack_public_path__ + "img/help-icon.8f1f238b.svg";